import { Select as NulogySelect } from "@nulogy/components";
import { useField, useFormikContext } from "formik";
import React, { useMemo } from "react";

export default function Select({ field: name, onChange, className, ...ndsProps }) {
  const { setFieldValue } = useFormikContext();
  const [field, meta, helpers] = useField(name);

  const handleChange = useMemo(
    () => (value) => {
      if (onChange) {
        onChange({ setFieldValue, value });
      }
      helpers.setValue(value);
    },
    [onChange, helpers, setFieldValue],
  );

  return (
    <NulogySelect
      className={className}
      errorMessage={meta.error}
      onChange={handleChange}
      value={field.value}
      {...ndsProps}
    />
  );
}
